"use strict";

var _interopRequireWildcard3 = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupCustomerTrans = exports.default = exports.GroupCustomer = exports.GenderTypeTrans = exports.GenderType = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var customer = _interopRequireWildcard3(require("@/api/customer"));
var _FilterCustomer = _interopRequireDefault(require("./components/FilterCustomer.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _enum = require("@/utils/enum");
var _ImportModal = _interopRequireDefault(require("./components/ImportModal.vue"));
var _initStore = require("@/store/initStore");
var _Excel = require("./components/Excel");
// import CustomerDialog from "./components/CustomerDialog.vue";

var CustomerTable = /*#__PURE__*/function (_Vue) {
  function CustomerTable() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listQuery", {
      page: 1,
      limit: 10,
      search: ""
    });
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "query", {});
    (0, _defineProperty2.default)(_this, "tableData", []);
    (0, _defineProperty2.default)(_this, "dataExport", []);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "isHadBirthdayThisMonth", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(CustomerTable, _Vue);
  return (0, _createClass2.default)(CustomerTable, [{
    key: "handleQuery",
    value: function handleQuery(query) {
      this.listQuery = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
        page: 1
      });
      // check filter khoảng thời gian ngày sinh mà không trùng với khoảng thời gian ngày sinh trong tháng thì checkbox sang false
      if (query.dobFrom != (0, _moment.default)().startOf("months").format("YYYY-MM-DD") || query.dobTo != (0, _moment.default)().endOf("months").format("YYYY-MM-DD")) {
        this.isHadBirthdayThisMonth = false;
      }
      this.query = query;
      this.getTableData();
    }
  }, {
    key: "calcAge",
    value: function calcAge(birthday) {
      return (0, _moment.default)().diff((0, _moment.default)(birthday, "DD/MM/YYYY").valueOf(), "years", false) || "--";
    }
    // xử lý lọc khách hàng có ngày sinh trong tháng
  }, {
    key: "handleFilterBirthdayThisMonth",
    value: function handleFilterBirthdayThisMonth() {
      this.isHadBirthdayThisMonth = !this.isHadBirthdayThisMonth;
      this.listQuery.page = 1;
      // check khi select khach hang co ngay sinh trong thang
      if (this.isHadBirthdayThisMonth) {
        this.query = {
          dobFrom: (0, _moment.default)().startOf("months").format("YYYY-MM-DD"),
          dobTo: (0, _moment.default)().endOf("months").format("YYYY-MM-DD")
        };
      } else {
        this.query = {};
      }
      this.getTableData();
    }
  }, {
    key: "handleFilter",
    value: function handleFilter() {
      this.$refs.filter.handleOpen(this.query);
    }
  }, {
    key: "handleImport",
    value: function handleImport() {
      this.$refs.importModal.handleOpen();
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.$refs["dialog"].handleCreate();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.dialog.handleUpdate(row);
    }
  }, {
    key: "created",
    value: function created() {
      var _this2 = this;
      this.getTableData();
      _initStore.customerRankStore.fetchData();
      _initStore.customerGroupStore.fetchData();
      _initStore.customerSourceStore.fetchData();
      _initStore.skinStatusStore.fetchData();
      if (!!this.$route.query.customerId) {
        setTimeout(function () {
          _this2.$refs.dialog.handleUpdate({
            id: _this2.$route.query.customerId
          });
        }, 1000);
      }
    }
  }, {
    key: "exportCustomer",
    value: function () {
      var _exportCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loadingExcel = true;
              _context.next = 3;
              return this.fetchCustomerExport();
            case 3:
              this.loadingExcel = false;
              (0, _Excel.exportCustomerExcel)({
                customer: this.dataExport
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function exportCustomer() {
        return _exportCustomer.apply(this, arguments);
      }
      return exportCustomer;
    }()
  }, {
    key: "fetchCustomerExport",
    value: function () {
      var _fetchCustomerExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), this.query);
              delete query.page;
              delete query.limit;
              _context2.next = 5;
              return customer.findAll(query);
            case 5:
              res = _context2.sent;
              this.dataExport = res.data.customers;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchCustomerExport() {
        return _fetchCustomerExport.apply(this, arguments);
      }
      return fetchCustomerExport;
    }()
  }, {
    key: "getTableData",
    value: function getTableData() {
      var _this3 = this;
      this.listLoading = true;
      customer.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), this.query)).then(function (res) {
        _this3.tableData = res.data.customers;
        _this3.total = res.data.total;
      }).finally(function () {
        _this3.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
CustomerTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("./components/CustomerDialog.vue"));
      });
    },
    FilterCustomer: _FilterCustomer.default,
    ImportModal: _ImportModal.default
  }
})], CustomerTable);
var _default = exports.default = CustomerTable;
var GroupCustomer;
(function (GroupCustomer) {
  GroupCustomer["Retail"] = "RETAIL";
  GroupCustomer["Wholesale"] = "WHOLESALE";
  GroupCustomer["Spa"] = "SPA";
})(GroupCustomer || (exports.GroupCustomer = GroupCustomer = {}));
var groupCustomerTrans = exports.groupCustomerTrans = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, GroupCustomer.Retail, "Retail"), GroupCustomer.Wholesale, "Whole sale"), GroupCustomer.Spa, "Spa");
var GenderType;
(function (GenderType) {
  GenderType["Male"] = "MALE";
  GenderType["Female"] = "FEMALE";
})(GenderType || (exports.GenderType = GenderType = {}));
var GenderTypeTrans = exports.GenderTypeTrans = {
  MALE: "Male",
  FEMALE: "Female"
};